"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATH_API = void 0;
exports.PATH_API = 'BranchingAPI';
const isPathApi = (api) => api === exports.PATH_API;
exports.default = isPathApi;
